import React from 'react';
import PropTypes from 'prop-types';

import PreviewIcon from '../../icons/preview.svg';
import styles from './index.module.scss';
import Button from '../Button/Button';
import { settingsAppUrl } from '../../../config';

const Preview = ({ userId }) => {
  // The preview is opened from the My Site dashboard, so linking to the dashboard
  // root sends the pro back to where they came from instead of to the editor.
  const editLink = `${settingsAppUrl}/mysite/${userId}/basic`;

  return (
    <div className={styles.preview}>
      <div className={styles.top}>
        <div className={styles.icon}>
          <PreviewIcon />
        </div>
        <div>
          <h4>Edit site contents</h4>
          <p>You can add more details about you and your business.</p>
        </div>
      </div>
      <a href={editLink} className={styles.button}>
        <Button variant="blue">
          <span>Edit site</span>
        </Button>
      </a>
    </div>
  );
};

Preview.propTypes = {
  userId: PropTypes.number
};

export default Preview;
